package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.onboarding.domain.models.SelectableOption

@Serializable
@SerialName("gender")
data class GenderScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("options") val options: List<SelectableOption> = emptyList(),
) : ScreenConfig